// Posts the document's content height to the parent window so a hosting page
// can size its iframe to match. Wire format matches webservice-forms'
// useIframeBridge: {type: 'mw-iframe-resize', height}. Debounced to avoid
// flapping when a layout settles over several ResizeObserver entries.

const RESIZE_TYPE = 'mw-iframe-resize'
const DEBOUNCE_MS = 150

function isIframed () {
  try { return window.top !== window.self } catch (e) { return true }
}

export function installIframeBridge () {
  if (!isIframed()) return
  let lastHeight = 0
  let timer

  const post = () => {
    timer = undefined
    const h = Math.ceil(document.documentElement.scrollHeight)
    if (h === lastHeight) return
    lastHeight = h
    window.parent.postMessage({ type: RESIZE_TYPE, height: h }, '*')
  }

  const schedule = () => {
    if (timer) clearTimeout(timer)
    timer = setTimeout(post, DEBOUNCE_MS)
  }

  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(schedule).observe(document.documentElement)
  } else {
    window.addEventListener('resize', schedule)
  }
  schedule()
}
